var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificateActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_1106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8V18",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 27C8.9625 23.99 12.1388 22 16 22C19.8612 22 23.0375 23.99 25 27",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 8L16 12L4 8L16 4L28 8Z",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1675 10.2775C22.0833 11.2797 22.6879 12.5266 22.9077 13.8664C23.1274 15.2061 22.9529 16.5808 22.4052 17.8231C21.8576 19.0654 20.9605 20.1216 19.8232 20.8631C18.686 21.6047 17.3576 21.9995 16 21.9995C14.6424 21.9995 13.314 21.6047 12.1768 20.8631C11.0395 20.1216 10.1424 19.0654 9.59478 17.8231C9.04713 16.5808 8.87256 15.2061 9.09232 13.8664C9.31208 12.5266 9.91669 11.2797 10.8325 10.2775",
    stroke: "#A68AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_1106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateActive);
export default __webpack_public_path__ + "static/media/CertificateActive.ab0c859a30df6856c45b23cfd438567f.svg";
export { ForwardRef as ReactComponent };